import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  capitalizeFirstLetters,
  formatAccount,
} from "../../features/ValueFormater";
import { useRowSelect, useTable } from "react-table";
import Table from "../../components/Table";
import { setRequestData } from "../../features/transactionDetailsSlice";
import { Checkbox } from "../../components/Checkbox";
import { useParams } from "react-router-dom";
import {
  setDeviceType,
  setIsApproveAll,
  setMobileResponse,
} from "../../features/appMobileSlice";
import useLoginAPI from "../../api/loginAPI";
import QuickPayApi from "../../api/QuickPayApi";
import authorizationMobileApi from "../../api/authorizationMobileApi";
import { setLoading } from "../../features/responseSlice";
import useResponseMobile from "../../app/useResponseMobile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripLines } from "@fortawesome/free-solid-svg-icons";
import UtcToLocal from "../../components/UtcToLocal";
import TransactionDetailsAPI from "../../api/TransactionDetailsAPI";

const CashAdvancePendingApprovalMobile = ({ setUrlData }) => {
  const [searchInput, setSearchInput] = useState("");

  const { quickPayDetails } = useSelector((state) => state.quickPay);
  const { transactionDetails } = useSelector(
    (state) => state.transactionDetails.response
  );

  const { MobileLogin } = useLoginAPI();
  const { GetQuickPaySummaryMobile, ApproveRejectQuickPayMobile } =
    QuickPayApi();
  const { generateAuthorizationCodeMobile, MobileAuthorize } =
    authorizationMobileApi();
  const { GetTransactionDetailsMobile } = TransactionDetailsAPI();

  const { successResponseMobile, errorResponseMobile } = useResponseMobile();

  const {
    id: UserAccountId,
    ts: TimeStamp,
    ref: reference,
    action: actionType,
    device: deviceType,
    sh: encodedSecureHash,
  } = useParams();

  sessionStorage.setItem(
    "secureHashencode",
    encodeURIComponent(encodedSecureHash)
  );

  useEffect(() => {
    dispatch(setDeviceType(deviceType));
  }, [deviceType]);

  const SecureHash = decodeURIComponent(encodedSecureHash);
  if (!sessionStorage.getItem("SecureHashSaved")) {
    sessionStorage.setItem("SecureHashSaved", SecureHash);
  }

  const secureHashSaved = SecureHash;

  useEffect(() => {
    async function fetchData() {
      const sessionMobile = sessionStorage.getItem("SessionMobile");
      const tokenMobile = sessionStorage.getItem("TokenMobile");

      const isInvalid =
        !sessionMobile ||
        !tokenMobile ||
        sessionMobile === "null" ||
        tokenMobile === "null" ||
        sessionMobile.trim() === "" ||
        tokenMobile.trim() === "";

      if (isInvalid) {
        try {
          await MobileLogin(
            UserAccountId,
            TimeStamp,
            reference,
            actionType,
            secureHashSaved
          );
        } catch (error) {
          console.error(error);
        }
      }
      await GetQuickPaySummaryMobile(reference);
      await GetTransactionDetailsMobile(reference);
    }
    fetchData();
  }, [UserAccountId, TimeStamp, reference, secureHashSaved]);

  useEffect(() => {
    setUrlData({
      id: UserAccountId,
      ts: TimeStamp,
      reference: reference,
      secure: secureHashSaved,
      deviceType: deviceType,
    });
  }, [UserAccountId, TimeStamp, reference, deviceType, secureHashSaved]);

  // const [onOpenQrAfterGenerate] = useOutletContext();

  const dispatch = useDispatch();
  const [setIsApproveButtonDisabled, setSetIsApproveButtonDisabled] =
    useState(false);

  const [cashAdvanceDetailsPayload, setCashAdvanceDetailsPayload] = useState(
    []
  );

  const options = {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  };

  const detailsColumns = useMemo(
    () => [
      {
        Header: "Employee",
        accessor: (row) => `${row.EmployeeFirstName} ${row.EmployeeLastName}`,
      },
      {
        Header: "test",
        accessor: "test",
      },
      {
        Header: "Phone Number",
        accessor: "PhoneNumber",
        Cell: ({ value }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: "In Advance Payment",
        accessor: "InAdvancePaymentAmount",
        Cell: ({ row, value }) => {
          return (
            <span>
              {formatAccount(value, row.original.InAdvancePaymentCurrency)}
            </span>
          );
        },
      },
      {
        Header: "Start Date",
        accessor: "StartDate",
      },
      {
        Header: "Status",
        accessor: "Status",
        Cell: ({ value }) => {
          if (value === "Correct" || value === "Checked") {
            return (
              <button
                style={{
                  color: "white",
                  fontFamily: "Poppins Medium ",
                  fontSize: "14px",
                  backgroundColor: "#199B2D",
                  borderRadius: "20px",
                  width: "120px",
                  padding: "5px 0",
                }}
              >
                {capitalizeFirstLetters(value)}
              </button>
            );
          }

          return <span>{value}</span>;
        },
      },
      {
        Header: "",
        accessor: "Reason",
      },
    ],
    [quickPayDetails]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable(
    { columns: detailsColumns, data: quickPayDetails },
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          {
            id: "selection",
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <Checkbox {...getToggleAllRowsSelectedProps()} />
            ),
            Cell: ({ row }) =>
              row.original.IsPayrollReference ||
              row.original.Method === "Quick Pay" ? null : (
                <Checkbox {...row.getToggleRowSelectedProps()} />
              ),
          },
          ...columns,
        ];
      });
    }
  );

  useEffect(() => {
    if (selectedFlatRows) {
      const isDisabled = selectedFlatRows.length === 0;
      const selectedRows = selectedFlatRows.map((row) => row.original);

      setSetIsApproveButtonDisabled(isDisabled);
      setCashAdvanceDetailsPayload([...selectedRows]);
    } else {
      setSetIsApproveButtonDisabled(true);
    }
  }, [selectedFlatRows]);

  const handleAction = async (method, singleQuickPayId = null) => {
    dispatch(setLoading("pending"));
    try {
      const response = await generateAuthorizationCodeMobile();
      const authCode = response?.Payload?.AuthorizationCode;

      if (!authCode) {
        console.error("No AuthorizationCode received");
        return;
      }

      await MobileAuthorize(authCode);

      const mobileResponsePromise = new Promise((resolve, reject) => {
        window.handleCheckout = (message) => {
          dispatch(setMobileResponse(message));
          resolve(message);
        };

        setTimeout(() => {
          reject(new Error("Mobile response timeout"));
        }, 10000);
      });

      if (deviceType === "Android") {
        setTimeout(() => {
          window.AndroidInterface?.callbackHandler?.("message");
        }, 500);
      } else if (deviceType === "Iphone") {
        setTimeout(() => {
          window.webkit?.messageHandlers?.callbackHandler?.postMessage(
            "fingerprint"
          );
        }, 500);
      }

      const mobileResponse = await mobileResponsePromise;

      const getQuickPayId = (item) => item?.UserAccountId ?? null;

      const targetItems =
        singleQuickPayId != null
          ? filteredQuickPayList.filter(
              (item) => getQuickPayId(item) === singleQuickPayId
            )
          : filteredQuickPayList;

      if (!targetItems.length) {
        console.error("No QuickPay rows found to submit");
        return;
      }

      const payload = {
        SessionID: sessionStorage.getItem("SessionMobile"),
        AuthorizationCode: authCode,
        quickPayDetailsList: targetItems,
        status: method === "approve" ? "Approve" : "Reject",
        CheckerAdvanceId: Number(reference),
      };

      if (mobileResponse === "success") {
        await ApproveRejectQuickPayMobile(payload)
          .then((res) => {
            successResponseMobile(res);
            const isOnlyOne = (filteredQuickPayList?.length || 0) === 1;

            if (!isOnlyOne) {
              GetQuickPaySummaryMobile(reference);
            }
          })
          .catch((error) => {
            errorResponseMobile(error);
            dispatch(setLoading("idle"));
          });
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setLoading("idle"));
    }
  };

  const getStatusClass = (status) => {
    if (!status) return "";
    const lowerStatus = status.toLowerCase();
    if (lowerStatus.includes("rejected")) return "rejected";
    if (lowerStatus.includes("sent")) return "sent";
    return "pending";
  };

  const formatStatus = (status) => {
    if (!status) return "";
    return status.startsWith("Pending") ? "Pending" : status;
  };

  const filteredQuickPayList = useMemo(() => {
    if (!Array.isArray(quickPayDetails)) return [];

    const q = searchInput.trim().toLowerCase();
    if (!q) return quickPayDetails;

    return quickPayDetails.filter((item) => {
      const name =
        item?.RecepientName ||
        `${item?.EmployeeFirstName || ""} ${
          item?.EmployeeLastName || ""
        }`.trim();

      const phone = item?.PhoneNumber || "";
      const reason = item?.Reason || "";
      const amount = String(item?.Amount ?? item?.InAdvancePaymentAmount ?? "");
      const status = item?.Status || "";

      return [name, phone, reason, amount, status]
        .join(" ")
        .toLowerCase()
        .includes(q);
    });
  }, [quickPayDetails, searchInput]);

  const handleClose = () => {
    if (deviceType === "Android") {
      window.AndroidInterface.callbackHandler("GoToApp");
    } else if (deviceType === "Iphone") {
      window.webkit.messageHandlers.callbackHandler.postMessage("GoToApp");
    }
  };

  return (
    <div className="PayrollMobilePage">
      <div className="search-filter">
        <FontAwesomeIcon className="grip-icon" icon={faGripLines} />
        <input
          type="text"
          className="search"
          placeholder="Search"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
      </div>

      <div className="payroll-details">
        <div className="payroll-top">
          <div className="top-section">
            <div className="title">Quick Pay Details</div>
            <div className="sub-title">Summary of quickpay</div>
          </div>

          <div className="summary-payroll mt-2">
            <div className="summary-card">
              <div className="card-cont">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex flex-column">
                    <div className="title">Advance on Salary</div>
                    <div className="sub-title">Quick Pay</div>
                  </div>
                  <div className="top-section-card">
                    <div className="status">
                      <div
                        className={`payroll-status ${getStatusClass(
                          transactionDetails?.Status
                        )}`}
                      >
                        {formatStatus(transactionDetails?.Status)}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="br mt-0"></div>

                <div className="data">
                  <div className="keys">
                    <div className="key">Date</div>
                    <div className="key">Issued by</div>
                  </div>
                  <div className="values">
                    <div className="value">
                      <UtcToLocal
                        utcTimestamp={transactionDetails?.Date}
                        options={options}
                      />
                    </div>
                    <div className="value">
                      {transactionDetails?.InitiatorName}
                    </div>
                  </div>
                </div>

                <div className="br"></div>

                <div className="data align-items-start">
                  <div className="keys">
                    <div className="key">Total Employees</div>
                  </div>
                  <div className="values">
                    <div className="value bold">
                      {transactionDetails?.TotalEmployees}
                    </div>
                  </div>
                </div>

                <div className="data">
                  <div className="keys">
                    <div className="key">Total Eligible</div>
                  </div>
                  <div className="values">
                    <div className="value">{transactionDetails?.Eligible}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bottom-title">
              Quick Pay is a salary advance of up to 50% of <br /> employee’s
              base salary, capped at $1,000.
            </div>

            <div className="approve">
              <button
                className="approve-btn"
                onClick={() => {
                  dispatch(setIsApproveAll(true));
                  handleAction("approve");
                }}
              >
                Approve {filteredQuickPayList?.length || 0}
              </button>
            </div>
          </div>
        </div>

        <div className="employees-list-list">
          <div className="sub-title">Eligible Employees</div>

          {filteredQuickPayList?.map((item, index) => (
            <div className="swipe-wrapper" key={index}>
              <div className="swipe-inner">
                <div className="employee-payroll-card">
                  <div className="card-top">
                    <div className="employee-data">
                      <div className="employee-name">
                        {item.EmployeeFirstName} {item.EmployeeLastName}
                      </div>
                      <div className="employee-number">+{item.PhoneNumber}</div>
                    </div>
                    <div className="employee-amount">
                      <div className="balance">
                        {formatAccount(
                          item.InAdvancePaymentAmount,
                          item.InAdvancePaymentCurrency
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="br"></div>

                  <div className="employee-reason">
                    <div className="reason">Start Date</div>
                    <div className="reason-data">{item.StartDate}</div>
                  </div>
                </div>

                <div className="swipe-actions">
                  <div
                    className="approve-swipe"
                    onClick={() => {
                      const isOnlyOne =
                        (filteredQuickPayList?.length || 0) === 1;
                      dispatch(setIsApproveAll(isOnlyOne));
                      handleAction("approve", item.UserAccountId);
                    }}
                  >
                    ✓
                  </div>

                  <div
                    className="cancel-swipe"
                    onClick={() => {
                      const isOnlyOne =
                        (filteredQuickPayList?.length || 0) === 1;
                      dispatch(setIsApproveAll(isOnlyOne));
                      handleAction("delete", item.UserAccountId);
                    }}
                  >
                    ✕
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div className="buttons">
            <div className="approve">
              <button
                className="approve-btn"
                onClick={() => {
                  dispatch(setIsApproveAll(true));
                  handleAction("approve");
                }}
              >
                Approve {filteredQuickPayList?.length || 0}
              </button>
            </div>
            <div className="cancel">
              <button
                className="cancel-btn"
                onClick={() => {
                  handleClose();
                }}
              >
                Not Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashAdvancePendingApprovalMobile;
